<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense flat >
            <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-toolbar-title>{{foreign.nameShort ? foreign.nameShort : formats.blank(foreign.name, (v) => v.slice(0, 30) + '...')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        <v-card-scroll v-show="foreign && foreign.id" flat md :offset="calcOffset(0, 0)">
          <v-card-text>
            <div><b>{{formats.blank(foreign.name)}}</b></div>
            <div>Страна: <b>{{formats.blank(foreign.countryName)}}</b> Код&nbspстраны:&nbsp<b>{{formats.blank(foreign.countryCode)}}</b></div>
            <div>Адрес: <b>{{formats.blank(foreign.address)}}</b></div>
            <br/>
            <div>Дата регистрации: <b>{{formats.blank(foreign.regDate, formats.formatDate)}}</b></div>
            <div>Регистрирующая организация: <b>{{formats.blank(foreign.regOrgName)}}</b></div>
            <div>Регистрационный номер: <b>{{formats.blank(foreign.regNumber)}}</b></div>
          </v-card-text>
        </v-card-scroll>
        </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import mixins from '../common/apimix.js'
  import server from '../../api/server'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'foreign-page',
    components: {vCardScroll},
    mixins: [mixins],
    data: () => ({
      foreign: null,
      showAllCompanies: false,
      favoriteLists: null,
      holders: []
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      }
    },
    created () {
      this.initForeign()
    },
    mounted () {
      if (this.itemId) {
        this.fetchForeignProps(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchForeignProps(newVal)
        } else {

        }
      }
    },
    computed: {
      ...mapGetters({
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs'
      })
    },
    methods: {
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      getForeignProps (id, cb) {
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о иностранной компании из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/foreigns/' + id,
          cb,
          cbError)
      },
      fetchForeignProps (id) {
        this.initForeign()
        this.getForeignProps(id, (data) => {
          this.foreign = data
        })
      },
      initForeign () {
        this.foreign = {
          id: null,
          inn: null,
          nameShort: '',
          name: ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForeignPage.vue?29edbac8